/* BPO */
import * as boletadorStore from './store'

export function boletadorModule({ store }) {
  store.registerModule('boletador', { ...boletadorStore, namespaced: true })
}

export const PERMISSION = 'boletador'
